/**
 * Track Submitted Form Action
 *
 * Records the formId of the section being submitted so that
 * only forms the patient actually completed get submitted to the API.
 */

import { assign } from "xstate";
import type { ActionWithMetadata } from "./save-form-data.action";

export const trackSubmittedForm: ActionWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState action params are complex
  impl: assign(({ event, context }: any) => {
    const sectionName = event.data?.sectionName;
    if (!sectionName) return {};

    const sections = (context.intakeFormSections || []) as Array<{
      formId: string;
      sectionName: string;
    }>;

    const section = sections.find((s) => s.sectionName === sectionName);
    if (!section) return {};

    const existing = (context.submittedFormIds || []) as string[];
    if (existing.includes(section.formId)) return {};

    return {
      submittedFormIds: [...existing, section.formId],
    };
  }),
  metadata: {
    displayName: "trackSubmittedForm",
    description: "Record formId of submitted intake section",
    category: "context",
  },
};
